<p>mac-collector-update-schedule works!</p>
